import { render, staticRenderFns } from "./W-Data-Table.vue?vue&type=template&id=11c450da&lang=pug"
import script from "./W-Data-Table.vue?vue&type=script&lang=js"
export * from "./W-Data-Table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports